import { render, staticRenderFns } from "./Bingo.vue?vue&type=template&id=ff79bd66&scoped=true"
import script from "./Bingo.vue?vue&type=script&lang=js"
export * from "./Bingo.vue?vue&type=script&lang=js"
import style0 from "./Bingo.vue?vue&type=style&index=0&id=ff79bd66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff79bd66",
  null
  
)

export default component.exports